// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "8ac3ad9e1fa7aa673952bd4e0eaa8baf" + ".js";
};